import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import { labelStyle } from './form'

/**
 * This basic component is for displaying a standard "Total" to the user
 * Can also be used to display any [label] = [value]
 * Primarily for standardized styling and responsiveness
 * of this type of element.
 */
export default class LabeledRowOutput extends Component {
  /**
   * Render component
   * @returns {XML}
   */
  render () {
    if (this.props.altLayout) {
      return (
        <Row style={this.props.rowStyle}>
          <Col
            style={labelStyle}
            xs={6}
            md={5}
            lg={4}
            className='inputAlignAlt'
          >
            {this.props.label}
          </Col>
          <Col xs={6} md={7} lg={8}>
            ${this.props.output}
          </Col>
        </Row>
      )
    } else {
      return (
        <Row style={this.props.rowStyle}>
          <Col xs={0} sm={1} lgHidden />
          <Col style={labelStyle} xs={12} sm={3} className='inputAlign'>
            {this.props.label}
          </Col>
          <Col xs={12} sm={8} lg={9}>
            ${this.props.output}
          </Col>
        </Row>
      )
    }
  }
}

LabeledRowOutput.propTypes = {
  label: PropTypes.string.isRequired,
  output: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  altLayout: PropTypes.bool,
  rowStyle: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/forms/LabeledRowOutput.js